import PropTypes from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import { toCapitalize } from 'yoda-site-components/lib/helpers/Utils/utils';
import checkoutStaticText from '../../helpers/LabelConstantsCheckout';
import * as styles from './BillingAddressDetails.css';

function BillingAddressDetails({ billingInfo, source }) {
    const city = billingInfo.country === 'AP' ? billingInfo.city : toCapitalize(billingInfo.city);
    const USCountries = ['US', 'AP', 'APO', 'FPO', 'DPO'];
    // Replaced includes as it is not supported in IE
    const international = !(USCountries.indexOf(billingInfo.country) > -1);
    return (
        <div>
            <p
                data-automation-id="at-review-billing-address-title"
                className={
                    source === 'review'
                        ? dt(['font-open-sans-semibold', 'text-medium'])
                        : dt(['font-open-sans-semibold'])
                }
            >
                {checkoutStaticText.BILLING_ADDRESS}
            </p>
            <div
                data-automation-id="at-review-billing-name"
                className={`${styles.addressLineOne} ${dt(['text-small'])}`}
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(billingInfo.firstName)} {toCapitalize(billingInfo.lastName)}
            </div>
            {billingInfo.company ? (
                <div
                    data-automation-id="at-review-billing-company"
                    className={`${styles.addressLineTwo} ${dt(['text-small'])}`}
                    data-qm-block="true"
                    data-tlprivate
                >
                    {toCapitalize(billingInfo.company)}{' '}
                </div>
            ) : null}
            <div
                data-automation-id="at-review-billing-line-one-two-three"
                className={`${styles.addressLineOne} ${dt(['text-small'])}`}
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(billingInfo.lineOne)}
                {billingInfo.lineTwo ? ', ' : ''}
                {billingInfo.lineTwo ? toCapitalize(billingInfo.lineTwo) : ''}
            </div>
            {!international ? (
                <div
                    data-automation-id="at-review-billing-city-state-zip"
                    className={`${styles.addressLineTwo} ${dt(['text-small'])}`}
                    data-qm-block="true"
                    data-tlprivate
                >
                    {city}, {billingInfo.state} {billingInfo.zip}{' '}
                </div>
            ) : null}
            {international ? (
                <div
                    data-automation-id="at-review-billing-city-state-zip"
                    className={`${styles.addressLineTwo} ${dt(['text-small'])}`}
                    data-qm-block="true"
                    data-tlprivate
                >
                    {city}, {billingInfo.state}{' '}
                </div>
            ) : null}
            {international ? (
                <div
                    data-automation-id="at-review-billing-city-state-zip"
                    className={`${styles.addressLineTwo} ${dt(['text-small'])}`}
                    data-qm-block="true"
                    data-tlprivate
                >
                    {billingInfo.country} {billingInfo.zip}{' '}
                </div>
            ) : null}
            {billingInfo.phone ? (
                <div
                    data-automation-id="at-review-billing-phone-number"
                    className={dt(['text-small', '!no-underline'])}
                    data-qm-block="true"
                    data-tlprivate
                >
                    {Formatter.format(billingInfo.phone, 0)}
                </div>
            ) : null}
        </div>
    );
}

BillingAddressDetails.defaultProps = {
    source: '',
};

BillingAddressDetails.propTypes = {
    billingInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        .isRequired,
    source: PropTypes.string,
};

export default BillingAddressDetails;
